import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/landingpage/landingpage.module').then((x) => x.LandingPageModule),
    canActivate: [],
  },
  {
    path: 'gestor',
    loadChildren: () =>
      import('./modules/administracion/administracion.module').then((x) => x.AdministracionModule),
    canActivate: [],
  },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // Mantener la posición del scroll
  anchorScrolling: 'enabled',          // Habilitar anclas
  scrollOffset: [0, 64],               // Opcional: Ajustar por un navbar fijo
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
